import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPermissionFilterParameters, PermissionFilter } from '@nimbus-global/features/menu/services/filters/permission.filter';

export class ExcludePermissionFilter extends PermissionFilter {
  public static for(parameter: IPermissionFilterParameters) {
    return { type: ExcludePermissionFilter, option: parameter };
  }

  public validate$(parameter: IPermissionFilterParameters): Observable<boolean> {
    return super.validate$(parameter).pipe(map((isValid) => !isValid));
  }
}
